import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';

const styles = {
  card: {
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    padding: '24px',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1f2937',
    marginBottom: '16px',
  },
};

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: '6px',
        padding: '10px 14px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        fontSize: '13px',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div style={{ fontWeight: 600, color: '#1f2937', marginBottom: '4px' }}>
        {label}
      </div>
      <div style={{ color: '#2563eb' }}>
        Index: <strong>{payload[0].value.toFixed(2)}</strong>
      </div>
    </div>
  );
}

export default function PriceIndexChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div style={styles.card}>
        <div style={styles.title}>CERTUS Price Index (Base: Oct 2025 = 100)</div>
        <div style={{ color: '#6b7280', textAlign: 'center', padding: '40px 0' }}>
          No index data available
        </div>
      </div>
    );
  }

  const values = data.map((d) => d.fisherIndex);
  const minVal = Math.min(...values);
  const maxVal = Math.max(...values);
  const padding = (maxVal - minVal) * 0.15 || 2;
  const yMin = Math.floor(Math.min(minVal - padding, 98));
  const yMax = Math.ceil(Math.max(maxVal + padding, 102));

  return (
    <div style={styles.card}>
      <div style={styles.title}>CERTUS Price Index (Base: Oct 2025 = 100)</div>
      <ResponsiveContainer width="100%" height={320}>
        <AreaChart data={data} margin={{ top: 10, right: 20, left: 10, bottom: 10 }}>
          <defs>
            <linearGradient id="indexFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#2563eb" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#2563eb" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 11, fill: '#6b7280' }}
            tickLine={false}
            axisLine={{ stroke: '#e5e7eb' }}
          />
          <YAxis
            domain={[yMin, yMax]}
            tick={{ fontSize: 11, fill: '#6b7280' }}
            tickLine={false}
            axisLine={{ stroke: '#e5e7eb' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <ReferenceLine
            y={100}
            stroke="#9ca3af"
            strokeDasharray="6 4"
            strokeWidth={1.5}
            label={{
              value: 'Baseline (100)',
              position: 'right',
              fontSize: 11,
              fill: '#9ca3af',
            }}
          />
          <Area
            type="monotone"
            dataKey="fisherIndex"
            stroke="#2563eb"
            strokeWidth={2.5}
            fill="url(#indexFill)"
            dot={false}
            activeDot={{ r: 5, fill: '#2563eb', stroke: '#fff', strokeWidth: 2 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
